import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faClose, faPlay } from '@fortawesome/pro-solid-svg-icons';
import { MD_BREAKPOINT, useWindowSize } from '@platzi/commons';
import { Image, Modal } from '@platzi/ui';
import { SelectPlan } from '../';
import styles from './Aside.module.sass';

export const Aside = () => {
  const { t } = useTranslation();
  const { width: screenWidth } = useWindowSize();

  const material = useSelector((state) => state.get('route').get('material_data'))?.toJS() || {};
  const teachers = useSelector((state) => state.get('route').get('teachers'))?.toJS() || [];
  const totalCourses = useSelector((state) => state.get('route').get('total_courses')) || 0;
  const totalHoursContent = useSelector((state) => state.get('route').get('total_hours_of_content')) || 0;

  const [isMobile, setIsMobile] = useState(true);
  const [showAllTeachers, setShowAllTeachers] = useState(false);

  useEffect(() => {
    screenWidth < MD_BREAKPOINT ? setIsMobile(true) : setIsMobile(false);
  }, [screenWidth]);

  const handleShowAllTeachers = () => {
    setShowAllTeachers(!showAllTeachers);
  };

  const showAllTeachersList = showAllTeachers && !isMobile ? teachers.length : 3;
  return (
    <div className={styles.Aside}>
      <div className={styles.Content}>
        <a className={styles.Thumbnail} href={material.material_url}>
          <Image src={material.thumbnail} alt={material.name} />
          <span>
            <FontAwesomeIcon icon={faPlay} />
          </span>
        </a>
        <div className={styles.ClassContent}>
          <h2 className={styles.ClassTitle}>{material.name}</h2>
          <div className={styles.Course}>
            <Image src={material.badge_url} alt={material.course_title} />
            <p>{material.course_title}</p>
          </div>
        </div>
        <div className={styles.RouteContent}>
          <figure>
            <FontAwesomeIcon icon={faBook} />
          </figure>
          <p>
            <p>
              {totalCourses} {t('route.aside.coursesInfoText')}
            </p>
          </p>
        </div>

        <div className={styles.TeachersContent}>
          <div className={styles.TeachersContentHeader}>
            <p className={styles.Title}>{t('route.aside.teachersTitle')}</p>
            <button className={styles.ShowMore} onClick={handleShowAllTeachers}>
              {showAllTeachers ? t('route.aside.seeLess') : t('route.aside.seeMore')}
            </button>
          </div>
          <ul>
            {teachers?.slice(0, showAllTeachersList).map((teacher, index: number) => (
              <li key={`teacher-${index}`}>
                <a href={teacher.profile_url}>
                  <Image src={teacher.avatar} alt={teacher.name} />
                  {teacher.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className={styles.ModalContainer}>
        <Modal show={showAllTeachers && isMobile} close={handleShowAllTeachers}>
          <div className={styles.TeachersHeaderModal}>
            <p>{t('route.aside.teachersTitle')}</p>
            <FontAwesomeIcon
              icon={faClose}
              className={styles.TeachersHeaderModalClose}
              onClick={handleShowAllTeachers}
            />
          </div>
          <div className={styles.TeachersContentModal}>
            <ul>
              {teachers.map((teacher, index: number) => (
                <li key={`teacher-${index}`}>
                  <a href={teacher.profile_url}>
                    <Image src={teacher.avatar} alt={teacher.name} />
                    {teacher.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </Modal>
      </div>
    </div>
  );
};
